import { useEffect, useState } from "react";
import { IPanelNuevoUbicacion } from "./PanelNuevoUbicacion";
import { codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { IUbicacionCommand } from "../../../../../Interfaces/auxiliar/IUbicacion";
import UbicacionService from "../../../../../services/auxiliar/UbicacionService";

export const UsePanelNuevoUbicacion=(props:IPanelNuevoUbicacion)=>{
    const [disableForm, setDisableForm] = useState<boolean>(true);
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const [request,setRequest]=useState<IUbicacionCommand>({nombre:"",codigo:"",nivel:props.nivel})
    const reset=()=>{
        setMensaje("")
        setRequest({nombre:"",codigo:"",nivel:props.nivel})
        setStatus(0)
        props.onDismiss()
    }
    const required: (keyof IUbicacionCommand)[] = [
        "nombre",
    ];
    useEffect(()=>{
        const check = required.every((field) => {
            const value = request[field];
            return value !== null && value !== undefined && value !== "";
          });
        setDisableForm(!check)
    },[request])
    const postInsertarIncidente=()=>{
        setLoading(true)
        UbicacionService.CreateUbicacionCompleto(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },
                3000)
                
            }else{
                setStatus(500)
                setMensaje("Error Inesperado");
            }
            setLoading(false)
           
        }).catch((e)=>{
              console.log('Error detallado:', e);
              setMensaje("Error Inesperado");
              setStatus(500);
              setLoading(false);
        })}
    return {request,setRequest,postInsertarIncidente,loading,disableForm,reset,mensaje,status}
}